import { createAsyncThunk } from '@reduxjs/toolkit'
import { showToast } from '../../../../shared/lib/showToast/showToast'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { fetchCommonClients, selectCommonUsers } from '../../../../entities/Common'
import { fetchClients } from '../../../../pages/ClientsPage'
import { selectNewClient } from '../selectors/selectNewClient'
import { INewClientDTO } from '../types/NewClient'
import { selectClientLabels } from '../../../DisplayClientLabels'
import { mapManagerNamesToIds } from '../mappers/mapManagerNamesToIds'
import { mapLabelNamesToIds } from '../mappers/mapLabelNamesToIds'

export const addNewClient = createAsyncThunk<string, void, ThunkConfig<string>>(
	'newClient/addNewClient',
	async (_, thunkAPI) => {
		const {
			dispatch,
			getState,
			// @ts-ignore
			extra: { api },
			rejectWithValue
		} = thunkAPI

		const newClient = selectNewClient(getState())
		const commonUsers = selectCommonUsers(getState())
		const clientLabels = selectClientLabels(getState())

		const managers = mapManagerNamesToIds(newClient.managerNames, commonUsers)
		const labels = mapLabelNamesToIds(newClient.labels!, clientLabels)

		if (!managers.length) {
			showToast({
				type: 'error',
				toastId: '#extra',
				message: 'Mangers chosen are not valid'
			})
			return
		}

		const companyNames = newClient.companyNames?.map((companyName) =>
			companyName?.trim()
		)

		const newClientDto: INewClientDTO = {
			companyNames,
			managers,
			labels
		}

		if (newClient.tfbOffice) newClientDto.tfbOffice = newClient.tfbOffice
		if (newClient.status) newClientDto.status = newClient.status

		try {
			// @ts-ignore
			const { data: { objectId } } = await api.post('/clients', newClientDto)

			showToast({
				type: 'success',
				toastId: 'newClientCreated',
				message: 'New client created'
			})

			dispatch(fetchClients())
			dispatch(fetchCommonClients())

			return objectId?.length ? objectId : ''
		} catch (e) {
			console.log(e)
			appHandleError(e, 'newClientCreated', 'Failed to add a new client')
			return rejectWithValue('Error occurred while creating a new client')
		}
	}
)
